/**
 * 按 UTF-16 长度截断,但不把 emoji 这类代理对劈成两半。
 *
 * `s.slice(0, n)` 数的是 UTF-16 单元,第 n 位恰好落在 👉 中间就会留下孤立的 `\ud83d`。
 * 2026-09-30 测试机:自由创作 productName 取 prompt 前 30 字,半个 👉 进了请求体,
 * ai 入队 redis 编码 UTF-8 时抛错 → 用户看到「AI 服务暂时不可用」。
 * 上限仍按 UTF-16 单元算(与后端 Java `@Size` 同一口径),只是末尾是半个就少取一位。
 */
export function sliceSafe(s: string, max: number): string {
  const out = s.slice(0, max);
  const last = out.charCodeAt(out.length - 1);
  return last >= 0xd800 && last <= 0xdbff ? out.slice(0, -1) : out;
}
